import * as yup from 'yup';

export const LogoSuggestionSchema = yup.object({
  logo: yup.mixed().nullable(),
});

export type ILogoSuggestion = yup.InferType<typeof LogoSuggestionSchema>;
